import { Button, FormError } from "@offstreetparking/design-system/forms";
import { classNames } from "@offstreetparking/design-system/utils";

type SelectionPromptButtonProps = {
	label: string;
	onClick: () => void;
	hasError?: boolean;
	errorMessage?: string;
	errorId?: string;
	isLoading?: boolean;
	isDisabled?: boolean;
};

export const SelectionPromptButton = ({
	label,
	onClick,
	hasError = false,
	errorMessage,
	errorId,
	isLoading = false,
	isDisabled = false,
}: SelectionPromptButtonProps) => {
	return (
		<div className="my-4 space-y-1">
			<Button
				type="button"
				intent="action"
				onClick={onClick}
				isLoading={isLoading}
				isDisabled={isDisabled}
				className={classNames(
					"w-full rounded-md border-2 border-neutral border-dashed py-6",
					hasError
						? "border-critical bg-critical-faded text-critical hover:opacity-90"
						: "border-info bg-info-faded text-info hover:opacity-90",
				)}
			>
				{label}
			</Button>
			<div role="alert" aria-atomic="true">
				{hasError && errorMessage && <FormError id={errorId} error={errorMessage} />}
			</div>
		</div>
	);
};
